import {
  formatDate,
  MbscCalendarEvent,
  MbscDatepickerOptions,
  MbscEventcalendarOptions,
  MbscEventcalendarView,
  MbscPopup,
  MbscPopupOptions,
  momentTimezone,
} from '@mobiscroll/angular';
import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PaymentService } from 'src/app/services/payment.service';
import { forkJoin, Observable } from 'rxjs';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { AppointmentNotesModel } from 'src/app/models/appointment-notes.model';
import { WORKING_TIME_CONFIG } from 'src/app/config/calendar.config';
import { environment } from 'src/environments/environment';

declare var jQuery: any;

const monthNames = [
  'Jan',
  'Feb',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  selector: 'app-app-appointment-all-details-v2',
  templateUrl: './app-appointment-all-details-v2.component.html',
  styleUrls: ['./app-appointment-all-details-v2.component.scss'],
})
export class AppAppointmentAllDetailsV2Component implements OnInit {
  action!: string;
  surveys: any;
  appNotesDetails: AppointmentNotesModel;
  appNotesDetailsList: AppointmentNotesModel[] = [];
  appNotesDetailsCurrent: any;
  submitted = false;
  isApptCompleted: boolean = false;
  selectedTests: any;
  selectedSurveys: any;
  paymentAmount: any;
  paymentSubmitted: boolean = false;
  totalAmount: any;
  paymentMade: any;
  remainingAmount: any;
  message: any;
  viewRecieptDetials!: any;
  paymentDetailsResponse!: any;
  assignedAdmin: any;
  directorAvailable: boolean = true;
  miscAdjustment: any;
  depositAdjustment: any;
  testSurveyComment: string = '';
  testSurveyBackComment: string = '';
  Unit: any = 1;
  Unit96130: any;
  Unit96131: any;
  Unit96138: any;
  Unit96139: any;
  Amount96130: any;
  Amount96131: any;
  Amount96138: any;
  Amount96139: any;
  documents: any = [];
  changeAssesmentType: any = [];
  currentDate = new Date();
  isModalOpen = false;
  notesCurrent: string = '';
  noteId: number = 0;
  followUpEdit: any;
  appBaseUrl = environment.appBaseUrl;

  @ViewChild('documentInput') documentInput!: ElementRef;
  @ViewChild('followUpModal') followUpModal!: ElementRef;
  constructor(
    private formBuilder: FormBuilder,
    private paymentService: PaymentService,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {
    //  this.updateClient= this.formBuilder.group({
    //     studentFirstName: ['',Validators.required]
    //   });

    this.appNotesDetails = new AppointmentNotesModel();
    this.appNotesDetailsCurrent = new AppointmentNotesModel();
  }
  pastDateValidator(): Validators {
    return (control: FormControl): { [key: string]: any } | null => {
      const inputDate = control.value ? new Date(control.value) : null;
      const currentDate = new Date();
      if (inputDate && inputDate > currentDate) {
        return { futureDate: true };
      }
      return null;
    };
  }

  updateClient = this.formBuilder.group({
    studentFirstName: ['', [Validators.required]],
    studentLastName: ['', [Validators.required]],
    parentName: ['', [Validators.required]],
    dateOfBirth: ['', [Validators.required, this.pastDateValidator()]],
    phoneNumber: ['', [Validators.required]],
    cellNumber: ['', [Validators.required]],
    emailAddress: [
      '',
      [
        Validators.required,
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
        ),
      ],
    ],
    secondaryEmailAddress: ['', [Validators.required]],
    grade: ['', [Validators.required]],
    reasonForCall: ['', [Validators.required]],
    schoolType: ['', [Validators.required]],
    school: ['', [Validators.required]],
    appointmentComments: ['', [Validators.required]],
    id: [''],
    address1: [''],
    address2: [''],
    city: [''],
    state: [''],
    zipCode: [''],
    appointmentId: [''],
  });

  updateAssementForm = this.formBuilder.group({
    assesmentType: new FormControl('', [Validators.required]),
  });

  addNotesForm = this.formBuilder.group({
    note: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      this.noWhitespace,
    ]),
  });
  updateNotesForm = this.formBuilder.group({
    note: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      this.noWhitespace,
    ]),
  });

  appointments: any = [];
  locationId: any = '';
  apptId: any;
  apptDetails: any;
  startAsses: boolean = false;
  comments: string = '';
  userRole: any;
  appts: any;
  appointmentComments: any;
  show: boolean = false;
  scheduleId: any;
  diagId: any;
  cancelAppt: boolean = false;
  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  fileInfos?: Observable<any>;
  status: any = '';
  resendConfirmationInProgress: boolean = false;
  resendReminderInProgress: boolean = false;
  followUpDetails: any;
  //paymentPaidStatus: boolean = false
  recieptSent: boolean = false;
  viewRecieptComponent: boolean = false;
  followUpCreated: boolean = false;
  viewReciept: boolean = false;
  inPersonZoomFollowUp = false;
  inPersonZoomFollowUpEdit = false;
  UserDaigAdmin: any = [];
  UserDirector: any = [];

  ngOnInit(): void {
    let location = null;
    let diagId = null;
    this.status = 'ALL';
    this.show = false;
    this.cancelAppt = false;
    this.spinner.show();
    //console.log('Page Open');
    this.userRole = this.auth.getUserType();
    this.activatedRoute.params.subscribe((params) => {
      this.apptId = params['id'];
    });
    this.userRole = this.authService.getUserType();
    if (this.userRole != 'ADMIN' && this.userRole != 'DIRECTOR') {
      diagId = this.authenticationService.getUserId();
    }
    // this.appointmentService.getAppointments(location, diagId, this.status, null, null, null).subscribe((res: any) => {
    //   this.appointments = res.data;

    //   this.show = true;

    //   this.spinner.hide()

    // })

    this.loadNotes();

    forkJoin({
      user: this.appointmentService.getUser(null, 1003),
      director: this.appointmentService.getUser(null, 1004),
    }).subscribe(({ user, director }) => {
      user.data.forEach((admin: any) => {
        this.UserDaigAdmin.push(admin);
      });
      this.UserDirector = director.data;
      director.data.forEach((dir: any) => {
        this.UserDaigAdmin.push(dir);
      });
    });

    forkJoin({
      requestOne: this.appointmentService.getAppointments(
        null,
        null,
        null,
        this.apptId,
        null,
        null
      ),
      requestTwo: this.paymentService.getPaymentDetails(
        this.apptId,
        null,
        null
      ),
    }).subscribe(({ requestOne, requestTwo }) => {
      this.apptDetails = requestOne.data[0];

      if (this.apptDetails.appointmentDetails.schedules.length > 1) {
        this.followUpCreated = true;
      }

      this.locationId = this.apptDetails.appointmentDetails.locationId;
      this.recieptSent = this.apptDetails.appointmentDetails.sendReceipt;

      let schedules = this.apptDetails.appointmentDetails.schedules;
      if (schedules[schedules.length - 1].status == 'FOLLOWUP') {
        this.status = 'FOLLOWUP';
        this.followUpDetails = schedules[schedules.length - 1];

        if (this.followUpDetails.meetingType === 'Online Follow Up (Zoom)') {
          this.inPersonZoomFollowUpEdit = true;
        }

        //console.log("****** ", this.followUpDetails);
      }

      this.diagId = this.apptDetails.appointmentDetails.diagnosticianId;
      this.resourceName = this.apptDetails.appointmentDetails.diagnosticianName;
      this.locationName = this.apptDetails.appointmentDetails.location;
      this.scheduleId =
        this.apptDetails.appointmentDetails.schedules[0].scheduleId;
      this.testSurveyComment =
        this.apptDetails.appointmentDetails.schedules[0].testSurveyComment;
      if (!this.testSurveyComment) {
        this.testSurveyComment = '';
      }
      if (
        this.apptDetails.appointmentDetails.schedules[0].status == 'COMPLETE'
      ) {
        this.isApptCompleted = true;
      }
      this.appointmentComments =
        this.apptDetails.appointmentDetails.schedules[0].appointmentComments;
      if (this.appointmentComments == '' || this.appointmentComments == null) {
        this.appointmentComments = '-';
      }
      this.appts = this.apptDetails.parentDetails;

      for (let i in this.appts) {
        if (this.appts[i] == '' || this.appts[i] == null) {
          this.appts[i] = '-';
        }
      }

      // this.paymentPaidStatus = requestTwo.data[0].status
      this.totalAmount = requestTwo.data[0].totalAmount;
      this.paymentMade = requestTwo.data[0].amount;
      this.remainingAmount = requestTwo.data[0].remaing;
      if (requestTwo.data[0].message == 'No pending payment') {
        this.paymentStatus = true;
      } else {
        this.paymentStatus = false;
      }
      this.show = true;
      this.spinner.hide();
      console.log('Page Close');
    });
    this.appointmentService.getDocument(this.apptId).subscribe((res) => {
      res.data.forEach((doc: any) => {
        this.documents.push(doc);
      });
      this.show = true;
    });
  }

  noWhitespace(control: AbstractControl): ValidationErrors | null {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  onInputRestrict(event: Event) {
    const input = event.target as HTMLInputElement;
    // This regex allows digits, plus, and minus signs only.
    const regex = /^[0-9+-]*$/;
    const lastChar = input.value.slice(-1);

    // If last entered character doesn't match the regex, remove it.
    if (!regex.test(lastChar)) {
      input.value = input.value.slice(0, -1);
    }

    // Update the model to reflect the changes.
    if (input.name === 'miscAdjustment') {
      this.miscAdjustment = input.value;
    } else if (input.name === 'depositAdjustment') {
      this.depositAdjustment = input.value;
    }
  }

  resetFileInput(): void {
    if (this.documentInput && this.documentInput.nativeElement) {
      this.documentInput.nativeElement.value = '';
      this.selectedFiles = undefined;
    }
  }

  getSurveys() {
    this.appointmentService
      .getTestsAndSuveys(this.apptId, this.scheduleId)
      .subscribe((res) => {
        if (res.data !== undefined) {
          this.surveys = res.data;
          this.testSurveyComment = res.data.testSurveyComment;
          this.testSurveyBackComment = res.data.testSurveyComment;
          if (
            this.testSurveyComment === null ||
            this.testSurveyComment === undefined ||
            this.testSurveyComment.length === 0
          ) {
            this.testSurveyComment = '';
            this.testSurveyBackComment = '';
          }
        }
      });
  }
  validationTest() {
    var testFlag = true;
    if (
      this.selectedSurveys === undefined ||
      this.selectedSurveys.length === 0
    ) {
      testFlag = false;
    } else {
      return true;
    }
    if (this.selectedTests === undefined || this.selectedTests.length === 0) {
      testFlag = false;
    } else {
      return true;
    }

    if (
      this.testSurveyComment === null ||
      this.testSurveyComment === undefined
    ) {
      testFlag = false;
    } else {
      if (
        this.testSurveyBackComment === this.testSurveyComment ||
        this.testSurveyComment.length === 0
      ) {
        testFlag = false;
        console.log(
          'testSurveyBackComment' +
            this.testSurveyBackComment +
            '    ' +
            this.testSurveyBackComment.length
        );
        if (this.testSurveyComment.length > this.testSurveyBackComment.length) {
          return true;
        }
      }
    }
    return testFlag;
  }

  onChangeSurveys() {
    console.log('change survey');
    console.log(this.validationTest());
    var surveys = this.surveys.surveysList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedSurveys = surveys;
    console.log(surveys);

    var tests = this.surveys.testsList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedTests = tests;
  }

  addSurveys() {
    // var surveys = this.surveys.surveysList
    //   .filter((opt: { checked: any; }) => opt.checked)
    //   .map((opt: any) => opt);
    // this.selectedSurveys = surveys;

    // var tests = this.surveys.testsList
    //   .filter((opt: { checked: any; }) => opt.checked)
    //   .map((opt: any) => opt);
    // this.selectedTests = tests;
    console.log(this.validationTest());
    if (!this.validationTest()) {
      return;
    }

    let selectedDetails = {
      tests: this.selectedTests,
      surveys: this.selectedSurveys,
      appointmentId: this.apptId,
      testSurveyComment: this.testSurveyComment,
      scheduleId: this.scheduleId,
    };
    this.appointmentService
      .saveSurveyDetails(selectedDetails)
      .subscribe((res) => {
        this.pageReload();
      });
  }

  // isPaymentValid(): boolean {
  //   const enteredAmount = parseFloat(this.paymentAmount || '0');
  //   const miscAdjustment = parseFloat(this.miscAdjustment || '0');
  //   const depositAdjustment = parseFloat(this.depositAdjustment || '0');

  //   const totalDue = this.totalAmount - this.paymentMade;
  //   const adjustedDue = totalDue + miscAdjustment + depositAdjustment;

  //   if (enteredAmount > adjustedDue) {
  //     return false;
  //   }
  //   return true;
  // }

  handlePaymentChange(): void {
    this.isPaymentAmountValid();
    // this.isPaymentValid();
  }

  submitPayment() {
    // if (!this.isPaymentValid()) {
    //   // Handle invalid payment logic
    //   alert("Invalid adjustment or payment amount.");
    //   return; // Stop the submission process
    // }
    //s console.log(this.paymentAmount)
    var flag = true;

    if (!this.isPaymentAmountValid()) {
      return;
    }

    this.spinner.show();
    jQuery('#paymentModal').modal('hide');
    //this.depositAdjustment
    this.paymentService
      .addPaymentDetails(
        this.apptId,
        this.paymentAmount,
        this.miscAdjustment,
        this.depositAdjustment
      )
      .subscribe(
        (res) => {
          this.paymentDetailsResponse = res;
          this.paymentSubmitted = true;

          setTimeout(() => {
            this.spinner.hide();

            jQuery('#appointmentScheduled').modal('show');
          });
        },
        (err) => {}
      );
  }
  pageReload() {
    location.reload();
  }
  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }

  upload(): void {
    this.progress = 0;

    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);

      if (file) {
        this.currentFile = file;
        this.appointmentService
          .uploadDocument(this.apptId, this.currentFile)
          .subscribe({
            next: (event: any) => {
              if (event.type === HttpEventType.UploadProgress) {
                this.progress = Math.round((100 * event.loaded) / event.total);
              } else if (event instanceof HttpResponse) {
                this.message = event.body.message;
              }
              if (this.progress == 100) {
                setTimeout(() => {
                  jQuery('#uploadModal').modal('hide');
                  jQuery('#docUploaded').modal('show');
                }, 2000);
              }
            },
            error: (err: any) => {
              this.progress = 0;

              if (err.error && err.error.message) {
                this.message = err.error.message;
              } else {
                this.message = 'Could not upload the file!';
              }

              this.currentFile = undefined;
            },
          });
      }

      this.selectedFiles = undefined;
      this.progress = 0;
    }
  }

  //
  openReciept() {
    this.appointmentService.viewReceipt(this.apptId).subscribe((res) => {
      this.viewRecieptDetials = res.data;
      //this.Unit = this.viewRecieptDetials.unit;
      this.Unit96130 = this.viewRecieptDetials.unit96130;
      this.Unit96131 = this.viewRecieptDetials.unit96131;
      this.Unit96138 = this.viewRecieptDetials.unit96138;
      this.Unit96139 = this.viewRecieptDetials.unit96139;
      this.Amount96130 = this.viewRecieptDetials.amount96130;
      this.Amount96131 = this.viewRecieptDetials.amount96131;
      this.Amount96138 = this.viewRecieptDetials.amount96138;
      this.Amount96139 = this.viewRecieptDetials.amount96139;

      //this.secondaryProvider = this.;
      this.viewReciept = true;

      setTimeout(() => {
        jQuery('#recieptModal').modal('show');
      });
    });
  }

  openFollowUpModal() {
    this.spinner.show();
    this.show = false;
    this.myResources = [];
    this.invalid = [
      {
        start: '0001-01-00',
        end: new Date(new Date().setDate(new Date().getDate() - 1)),
      },
    ];
    this.events = null;

    forkJoin({
      // user:     this.appointmentService.getUser(null, 1003),
      director: this.appointmentService.getUser(this.locationId, 1004),
      allApointment: this.appointmentService.getAppointments(
        null,
        null,
        null,
        null,
        null,
        null
      ),
      requestThree: this.appointmentService.getDiagUnavailability(
        null,
        this.locationId,
        1004
      ),
    }).subscribe(({ director, allApointment, requestThree }) => {
      if (director.data.length == 0) {
        this.directorAvailable = false;
      } else {
        this.directorAvailable = true;
      }
      director.data.forEach((dir: any) => {
        let diagdetails = {
          id: dir.id,
          name: dir.firstName,
          img: 'https://img.mobiscroll.com/demos/m2.png',
        };
        this.myResources.push(diagdetails);
      });

      allApointment.data.forEach((el: any) => {
        let schedules = el.appointmentDetails.schedules;
        // console.log("length    " + schedules.length);
        if (schedules[schedules.length - 1].status == 'FOLLOWUP') {
          let appt = schedules[schedules.length - 1];
          if (schedules[0].status != 'CANCEL') {
            this.invalid.push(appt);
          }
        }
      });

      this.events = requestThree;
      this.events.data.forEach((element: any) => {
        this.invalid.push(element);
      });
      this.events.dataRec.forEach((element: any) => {
        this.invalid.push(element);
      });

      setTimeout(() => {
        jQuery('#followUpModal').modal('show');
      });

      this.spinner.hide();
      this.show = true;
    });
  }

  getSchool() {
    this.spinner.show();

    forkJoin({
      requestThree: this.appointmentService.getSchoolType(),
    }).subscribe(
      ({ requestThree }) => {
        this.schoolType = requestThree.data;
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }
  updateClientMethod() {
    this.getSchool();
    this.updateClient.setValue({
      studentFirstName: this.appts.studentFirstName,
      studentLastName: this.appts.studentLastName,
      parentName: this.appts.parentName,
      dateOfBirth: this.appts.dateOfBirth,
      phoneNumber: this.appts.phoneNumber,
      cellNumber: this.appts.cellNumber,
      emailAddress: this.appts.emailAddress,
      secondaryEmailAddress: this.appts.secondaryEmailAddress,
      grade: this.appts.grade,
      reasonForCall: this.appts.reasonForCall,
      schoolType: this.appts.schoolType,
      school: this.appts.school,
      appointmentComments: this.appointmentComments,
      id: this.appts.clientId,
      address1: this.appts.address1,
      address2: this.appts.address2,
      city: this.appts.city,
      state: this.appts.state,
      zipCode: this.appts.zipCode,
      appointmentId: this.apptId,
    });
  }
  onClickSubmit() {
    this.spinner.show();
    console.log('server');
    this.appointmentService
      .updateClient(this.updateClient.value)
      .subscribe((res) => {
        jQuery('#editClientInfo').modal('hide');
        this.pageReload();
      });

    this.spinner.hide();
  }

  resendClientBackgroundEmail() {
    if (!this.apptId || this.resendConfirmationInProgress) {
      return;
    }

    this.resendConfirmationInProgress = true;
    this.spinner.show();
    this.appointmentService
      .resendClientBackgroundEmail(this.apptId)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.resendConfirmationInProgress = false;
          if (res.code === '200') {
            jQuery('#clientBackgroundEmailResent').modal('show');
          } else {
            jQuery('#errorModal').modal('show');
          }
        },
        () => {
          this.spinner.hide();
          this.resendConfirmationInProgress = false;
          jQuery('#errorModal').modal('show');
        }
      );
  }

  sendBackgroundFormReminderEmail() {
    if (!this.apptId || this.resendReminderInProgress) {
      return;
    }

    this.resendReminderInProgress = true;
    this.spinner.show();
    this.appointmentService
      .sendBackgroundFormReminderEmail(this.apptId)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.resendReminderInProgress = false;
          if (res.code === '200') {
            jQuery('#clientBackgroundEmailResent').modal('show');
          } else {
            jQuery('#errorModal').modal('show');
          }
        },
        () => {
          this.spinner.hide();
          this.resendReminderInProgress = false;
          jQuery('#errorModal').modal('show');
        }
      );
  }

  CreateFollowUp() {
    this.spinner.show();
    var startDate = new Date(this.tempEvent.start as Date);
    // var userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
    // startDate = new Date(startDate.getTime() - userTimezoneOffset);

    var endDate = new Date(this.tempEvent.end as Date);
    // var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    // endDate = new Date(endDate.getTime() - userTimezoneOffset);
    if (this.assessmentDate.trim().length < 0) {
      let year = startDate.getFullYear();
      let monthName = monthNames[startDate.getMonth()];
      let day = startDate.getDate();

      this.assessmentDate = monthName + ' ' + day + ', ' + year;
      this.appointmentTime =
        startDate.toLocaleString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }) +
        ' - ' +
        endDate.toLocaleString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
    }

    let followUpRequest = {
      title: this.popupEventTitle,
      appointmentDate: this.assessmentDate,
      appointmentTime: this.appointmentTime,
      appointmentId: this.apptId,
      start: startDate,
      end: endDate,
      appointmentComments: '',
      resource: this.tempEvent.resource,
      inZoom: this.inPersonZoomFollowUp,
    };

    this.appointmentService.submitFollowUp(followUpRequest).subscribe((res) => {
      this.spinner.hide();
      jQuery('#followupScheduledModal').modal('show');
    });
  }

  getAdminName() {
    this.myResources.forEach((element) => {
      if (element.id == this.tempEvent.resource) {
        this.assignedAdmin = element.name;
      }
      setTimeout(() => {
        jQuery('#followupConfirmationModal').modal('show');
      });
    });
  }

  openPaymentModal() {
    this.miscAdjustment = '';
    this.depositAdjustment = '';
    this.paymentAmount = '';
    jQuery('#paymentModal').modal('show');
  }
  openCancelApptModal() {
    this.comments = '';
    jQuery('#cancelApptModal').modal('show');
  }
  CancelAppt() {
    let action = 'CANCEL';
    jQuery('#cancelApptModal').modal('hide');
    this.spinner.show();
    this.appointmentService
      .updateAppts(action, this.apptId, this.comments, this.scheduleId)
      .subscribe((res) => {
        this.spinner.hide();
        this.router.navigate(['/view']);
      });
  }

  HoldAndUnHoldAppt(action: any) {
    //  let action = "HOLD"
    this.spinner.show();
    this.appointmentService
      .updateAppts(action, this.apptId, this.comments, this.scheduleId)
      .subscribe((res) => {
        this.spinner.hide();
        this.router.navigate(['/view']);
      });
  }

  validationRadio(): boolean {
    // Check if at least one radio button is selected
    return this.comments === 'Cancel' || this.comments === 'Reschedule';
  }

  sendReciept() {
    let details = {
      clientName:
        this.appts.studentFirstName + ' ' + this.appts.studentLastName,
      appointmentId: this.apptId,
      appointmentDate:
        this.apptDetails.appointmentDetails.schedules[0].appointmentDate,
      location: this.locationName,
      primaryProvider: this.primaryProvider,
      secondaryProvider: this.secondaryProvider,
      PrimaryDiagnosis: this.primaryDiagnosis,
      SecondaryDiagnosis: this.secondaryDiagnosis,
      diagnosis: this.diagnosis,
      AssessmentAmount: this.totalAmount,
      RecievedAmount: this.paymentMade,
      assesmentType: this.typeOfEvaluation,
      unit: this.Unit,
      unit96130: this.Unit96130,
      unit96131: this.Unit96131,
      unit96138: this.Unit96138,
      unit96139: this.Unit96139,
      amount96130: this.Amount96130,
      amount96131: this.Amount96131,
      amount96138: this.Amount96138,
      amount96139: this.Amount96139,
    };
    this.appointmentService.sendReceipt(details).subscribe((res) => {
      location.reload();
    });
  }

  //  calendar code

  @ViewChild('popup', { static: false })
  popup!: MbscPopup;
  @ViewChild('colorPicker', { static: false })
  colorPicker: any;
  popupEventTitle: string | undefined;
  popupEventDescription = '';
  popupEventAllDay = true;
  popupEventDates: any;
  todayDate: any;
  selectTimeSlots = 'slot1';
  calendarSelectedDate: any = new Date();
  switchLabel: any = 'All-day';
  tempColor = '';
  selectedColor = '';
  tempEvent!: MbscCalendarEvent;
  appointmentStartTime!: string;
  appointmentEndTime!: string;
  appointmentTime!: string;
  testTypes: any = [];
  schoolType: any;
  ifloaded: boolean = false;

  selectedDiag: any = '';
  reset: any = 'Close';
  clickToCreate: any = 'single';
  resourceName: any;
  appointmentDetails: any = {};
  appointmentId!: number;
  clientId!: number;
  selectedTime: any;

  modalDisabled: boolean = true;
  assessmentDate: any;
  diagnosticians: any;
  paymentStatus: boolean = false;
  paymentResponse: any = {};
  locationName: any;

  calendarOptions: MbscEventcalendarOptions = {
    min: new Date(),
    clickToCreate: this.clickToCreate,
    dragToCreate: false,
    dragToMove: false,
    dragToResize: false,
    view: {
      schedule: { type: 'week' },
    },
    timezonePlugin: momentTimezone,

    displayTimezone: 'America/Chicago',

    onEventClick: (args) => {
      this.isEdit = true;
      this.tempEvent = args.event;
      // fill popup form with event data
      if (
        this.tempEvent.title ==
        this.apptDetails.parentDetails.studentFirstName + "'s " + 'Follow Up'
      ) {
        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'Edit Follow Up';
        this.popupButtons = this.popupEditButtons;
        this.popupAnchor = args.domEvent.currentTarget;
        // open the popup
        this.popup.open();
      }
    },
    onEventCreated: (args) => {
      console.log(args);
      setTimeout(() => {
        this.isEdit = false;
        this.tempEvent = args.event;
        this.tempEvent.title = 'Follow Up';
        this.selectedTime = this.tempEvent.start;

        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'Follow Up';
        this.popupButtons = this.popupAddButtons;
        this.popupAnchor = args.target;
        // open the popup
        this.popup.open();
        // }
      });
    },
    onEventDeleted: (args) => {
      setTimeout(() => {
        this.deleteEvent(args.event);
      });
    },
    onEventUpdated: (args) => {
      // here you can update the event in your storage as well, after drag & drop or resize
      this.saveEvent();
    },
  };
  popupHeaderText!: string;
  popupAnchor: HTMLElement | undefined;
  popupAddButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupEditButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupButtons: any = [];
  popupOptions: MbscPopupOptions = {
    display: 'bottom',
    contentPadding: false,
    fullScreen: true,
    onClose: () => {
      if (!this.isEdit) {
        // refresh the list, if add popup was canceled, to remove the temporary event
        this.myEvents = [...this.myEvents];
      }
    },
    responsive: {
      medium: {
        display: 'anchored',
        width: 350,
        fullScreen: false,
        touchUi: false,
      },
    },
  };
  datePickerControls = ['date'];
  datePickerResponsive: any = {
    medium: {
      controls: ['time'],
      touchUi: false,
    },
  };
  datetimePickerControls = ['time'];
  datetimePickerResponsive = {
    medium: {
      controls: ['calendar', 'time'],
      touchUi: false,
    },
  };
  datePickerOptions: MbscDatepickerOptions = {
    min: new Date(), // set the minimum date to today
    select: 'range',
    showRangeLabels: false,
    touchUi: true,
  };
  isEdit = false;

  loadPopupForm(event: MbscCalendarEvent): void {
    this.popupEventTitle =
      this.apptDetails.parentDetails.studentFirstName +
      ' ' +
      this.apptDetails.parentDetails.studentLastName +
      "'s " +
      'Follow Up';
    this.popupEventDescription = event['description'];
    this.popupEventDates = [
      new Date(event.start as Date),
      new Date(event.end as Date),
    ];
  }
  saveEvent(): void {
    this.tempEvent.title = this.popupEventTitle;
    this.tempEvent['description'] = this.popupEventDescription;
    this.tempEvent.start = this.popupEventDates[0];
    this.tempEvent.end = this.popupEventDates[1];
    const start = new Date(this.tempEvent.start as Date);

    let year = start.getFullYear();
    let monthName = monthNames[start.getMonth()];
    let day = start.getDate();

    this.assessmentDate = monthName + ' ' + day + ', ' + year;
    var end = new Date(this.tempEvent.end as Date);
    this.appointmentTime =
      start.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }) +
      ' - ' +
      end.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    if (this.isEdit) {
      // update the event in the list
      this.myEvents = [...this.myEvents];
      // here you can update the event in your storage as well
      // ...
    } else {
      // add the new event to the list
      this.myEvents = [...this.myEvents, this.tempEvent];
      // here you can add the event to your storage as well
      // ...
    }
    // navigate the calendar
    this.calendarSelectedDate = this.popupEventDates[0];
    this.reset = 'Reset';
    this.clickToCreate = '';

    // close the popup
    this.popup.close();
  }
  deleteEvent(event: MbscCalendarEvent): void {
    if (this.reset == 'Reset') {
      this.myEvents = this.myEvents.filter((item) => item.id !== event.id);
      this.reset = 'Close';
      this.assessmentDate = '';
      this.appointmentTime = '';
      this.clickToCreate = 'single';
    }
  }
  // createDefaultEvent(): MbscCalendarEvent {
  //   // Create and return a default MbscCalendarEvent object
  //   // Adjust the properties according to your application's needs
  //   return {
  //     title:'',
  //     start: new Date(),
  //     end: new Date(),
  //     // ... other default properties
  //   };
  // }

  onDeleteClick(): void {
    if (this.reset === 'Reset') {
      // Reset the form and change the button to 'Close'
      this.resetCalendarState();
      this.reset = 'Close';
    } else {
      // Close the modal
      this.closeModal();
    }
  }

  closeModal(): void {
    // Using jQuery method to hide the modal
    jQuery(this.followUpModal.nativeElement).modal('hide');
  }

  resetCalendarState(): void {
    this.popupEventTitle = undefined;
    this.popupEventDescription = '';
    this.popupEventDates = null;
    this.popupEventAllDay = true;
    this.selectedTime = null;
    this.clickToCreate = 'single';

    this.myEvents = [];
  }

  view: MbscEventcalendarView = {
    schedule: {
      type: 'week',
      allDay: false,
      startDay: 1,
      endDay: 7,
      startTime: WORKING_TIME_CONFIG.start,
      endTime: WORKING_TIME_CONFIG.end,
    },
  };

  myEvents: MbscCalendarEvent[] = [];

  invalid: any = [
    {
      start: '0001-01-00',
      end: new Date(new Date().setDate(new Date().getDate() - 1)),
    },
  ];

  myResources: any[] = [];

  formatDate = formatDate;
  events: any;

  primaryProvider = 'Laurie Gaines-Peterson M. Ed, MA, LPC';
  secondaryProvider = '';
  primaryDiagnosis = '';
  typeOfEvaluation = '';
  secondaryDiagnosis = '';
  diagnosis = '';
  diagnosisList = [
    'DSM-V-314.01 - ADHD Combined ICD10-F90.2',
    'DSM-V-314.1 - ADHD  Hyperactive/Impulsive ICD10-F90.1 ',
    'DSM-V-314.00 - ADHD   Inattentive  ICD10-F90.0',
    'DSM-V-315.1 -  Learning Disorder  Mathematics ICD10-F81.2',
    'DSM-V-315.00 - Learning Disorder Reading ICD10-F81.81',
    'DSM-V-315.2 - Learning Disorder - Writing  ICD10-F81.81 ',
    'DSM-V-300.2 Generalized Anxiety Disorder ICD10 -F41.1   ',
    'Intellectual Disability - Mild  ICD10-F70',
    'Intellectual Disability - Moderate ICD10-F7  ',
    'DSM-V9V71.09 - No Diagnosis ICD10-Z03.89   ',
    'F80.2 – Language Disorder',
  ];

  selectedSecondaryDiagnosis(event: any) {
    this.secondaryDiagnosis = event.target.value;
  }
  selectedDiagnosis(event: any) {
    this.diagnosis = event.target.value;
  }
  selectedPrimaryDiagnosis(event: any) {
    this.primaryDiagnosis = event.target.value;
  }

  selectedtypeOfEvaluation(event: any) {
    this.typeOfEvaluation = event.target.value;
  }
  selectedSecandarProvider(event: any) {
    this.secondaryProvider = event.target.value;
  }

  onGradeChange(deviceValue: string) {
    if (deviceValue == 'Adult' || deviceValue == 'College') {
      this.updateClient.controls['parentName'].removeValidators([
        Validators.required,
      ]);
      this.updateClient.controls['parentName'].updateValueAndValidity();
    } else {
      this.updateClient.controls['parentName'].setValidators([
        Validators.required,
      ]);
      this.updateClient.controls['parentName'].touched;
      this.updateClient.controls['parentName'].errors;
      this.updateClient.controls['parentName'].updateValueAndValidity();
    }
  }

  getAssementType() {
    this.spinner.show();
    // this.updateAssementForm.reset();
    this.updateAssementForm.controls['assesmentType'].setValue('');
    // this.updateAssementForm.setValue({assessmentType:'Assessment Type'});
    this.appointmentService.getTestTypes().subscribe(
      (res) => {
        if (res.code == '200') {
          this.changeAssesmentType = res.data;
        } else {
          jQuery('#errorModal').modal('show');
          this.spinner.hide();
          return;
        }
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }
  updateAssesmentType() {
    this.spinner.show();
    // console.log("server");
    this.appointmentService
      .updateAssesmentType(
        Number(this.apptId),
        this.updateAssementForm.controls['assesmentType'].value
      )
      .subscribe((res) => {
        if (res.code == '200') {
          jQuery('#editAssementType').modal('hide');
          this.spinner.hide();
          this.pageReload();
        }
      });
  }
  isNumericPayment(): boolean {
    const numberPayment = Number(this.paymentAmount);
    if (isNaN(numberPayment)) {
      return true;
    } else {
      return false;
    }
  }

  isPaymentAmountValid(): boolean {
    // Check if paymentAmount is not numeric
    if (this.isNumericPayment()) {
      return false;
    }

    // Check if at least one of the three values is entered
    return (
      (this.paymentAmount !== null && this.paymentAmount !== '') ||
      (this.miscAdjustment !== null && this.miscAdjustment !== '') ||
      (this.depositAdjustment !== null && this.depositAdjustment !== '')
    );
  }

  get f() {
    return this.updateClient.controls;
  }
  get fNotes() {
    return this.addNotesForm.controls;
  }
  get fUNotes() {
    return this.updateNotesForm.controls;
  }

  loadNotes() {
    this.appointmentService.getApptNotesV2(this.apptId).subscribe((res) => {
      if (res.data !== undefined) {
        if (res.code === '200') {
          this.appNotesDetailsList = res.data;
        }
      }
    });
  }

  openAddNotesModeal() {
    this.submitted = false;
    jQuery('#addNotesModal').modal('show');
  }

  onCloseNotes() {
    // this.addNotesForm.controls['note'].setValue('');
    this.addNotesForm.reset();
    // if(this.submitted){
    // this.addNotesForm.reset();
    //  this.submitted = false;
    // }
    this.notesCurrent = '';
    jQuery('#addNotesModal').modal('hide');

    // this.addNotesForm.controls['note'].setValue('');
  }

  addNotes() {
    this.spinner.show();
    this.submitted = true;
    if (this.addNotesForm.invalid) {
      this.spinner.hide();
      return;
    }
    let addNotes = {
      note: this.addNotesForm.controls['note'].value,
      appointmentId: this.apptId,
    };
    this.appointmentService.addApptNotes(addNotes).subscribe((res) => {
      if (res.code === '200') {
        this.appNotesDetailsList = res.data;
      }
    });
    jQuery('#addNotesModal').modal('hide');
    this.addNotesForm.reset();
    this.notesCurrent = '';
    this.spinner.hide();
  }

  getMeetingType(meetingType: string) {
    if (meetingType) {
      return meetingType;
    } else {
      return 'NA';
    }
  }

  editNotes(appNotesDetails: AppointmentNotesModel) {
    this.submitted = false;
    this.appNotesDetailsCurrent = appNotesDetails;
    this.notesCurrent = appNotesDetails.note;
    this.noteId = appNotesDetails.id;
    // console.log("notes Current,",this.appNotesDetailsCurrent)

    jQuery('#editNotesModal').modal('show');
  }

  updateNotes() {
    this.spinner.show();
    this.submitted = true;
    if (this.updateNotesForm.invalid) {
      this.spinner.hide();
      return;
    }
    let updateNotes = {
      note: this.updateNotesForm.controls['note'].value,
      id: this.noteId,
    };
    this.appointmentService.updateNotes(updateNotes).subscribe((res) => {
      if (res.code === '200') {
        this.appNotesDetails = res.data;
        this.loadNotes();
      }
    });

    jQuery('#editNotesModal').modal('hide');
    this.updateNotesForm.reset();
    this.notesCurrent = '';
    this.noteId = 0;
    this.spinner.hide();
  }

  onCloseEditNotes() {
    this.updateNotesForm.reset();
    this.notesCurrent = '';
    this.noteId = 0;
    jQuery('#editNotesModal').modal('hide');
  }

  openEditFollowupModeal(followUpId: any) {
    this.followUpEdit = followUpId;
    // console.log("Followup Id:"+this.followUpEdit);
    this.submitted = false;
    jQuery('#editFollowupConfirmationModal').modal('show');
  }

  editFollowUp() {
    this.spinner.show();

    let followUpRequest = {
      appointmentId: this.apptId,
      scheduleId: this.followUpEdit.scheduleId,
      inZoom: this.inPersonZoomFollowUpEdit,
    };
    console.log(followUpRequest);
    this.appointmentService
      .submitfollowupEdit(followUpRequest)
      .subscribe((res) => {
        this.spinner.hide();
        jQuery('#editFollowupConfirmationModal').modal('hide');
        this.pageReload();
      });
  }
}
